import React from 'react';
import { Alert as AlertMUI } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as SC from './Alert.sc';
import { useGlobalState } from '../../store/GlobalStateContext';

export const Alert = ({ data }) => {
  // eslint-disable-next-line no-unused-vars
  const [globalState, dispatchGlobalState] = useGlobalState();
  const {
    text = 'Example of alert',
    isVisible = false,
    type = 'warning',
  } = data;

  const handleClose = () => {
    dispatchGlobalState({ type: 'HIDE_ALERT' });
  };

  return (
    <SC.Container style={{ display: isVisible ? 'flex' : 'none' }}>
      <AlertMUI severity={type}>
        <SC.AlertTitle>
          <span>
            {type.slice(0, 1).toUpperCase()}
            {type.slice(1).toLowerCase()}
          </span>
          <SC.IconHolder onClick={handleClose}>
            <CloseIcon />
          </SC.IconHolder>
        </SC.AlertTitle>
        {text}
      </AlertMUI>
    </SC.Container>
  );
};
